import React from 'react';
import styled, { css } from 'styled-components';
import { linkStyles } from '~/components/molecule/Link';
import Label from '../components/Label';
import { LinkBlock, LinkBlockType } from '~/graphql/types';

export type Props = Omit<LinkBlock, '__typename'> & {
  dataTestId?: string;
};

const LinkBlockComponent: React.FC<Props> = ({ label, linkValue, css }) => {
  const prefix = getPrefixForLink(linkValue);

  return (
    <>
      {label && <Label>{label}</Label>}
      <Anchor
        href={`${prefix}${linkValue.href}`}
        $css={css}
        target="_blank"
        rel="noopener noreferrer"
      >
        {linkValue.label ?? linkValue.href}
      </Anchor>
    </>
  );
};

export default LinkBlockComponent;

const Anchor = styled.a<{ $css?: string | null }>(
  ({ $css }) => css`
    ${linkStyles}

    ${$css &&
    css`
      ${$css}
    `}
  `,
);

const getPrefixForLink = (value: Props['linkValue']): string => {
  switch (value.type) {
    case LinkBlockType.Email:
      return 'mailto:';
    case LinkBlockType.Phone:
      return 'tel:';

    default:
      return '';
  }
};
